import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';

import { FeedingPage } from '../pages/feeding/feeding';
import { DiapersPage } from "../pages/diapers/diapers";
import { HomePage } from '../pages/home/home';
import { TabsPage } from '../pages/tabs/tabs';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { DataServiceProvider } from '../providers/data-service/data-service';

import * as firebase from 'firebase';
import { FeedingModalComponent } from '../components/feeding-modal/feeding-modal';
import { DiaperModalComponent } from '../components/diaper-modal/diaper-modal';
import { SignupPage } from "../pages/signup/signup";
import { LoginPage } from "../pages/login/login";
import { IonicStorageModule } from "@ionic/storage/es2015";
import { TypesModalComponent } from '../components/types-modal/types-modal';

export const config = {
      apiKey: "AIzaSyAo9n5Vjh-1CmGYntqTl6xaMVWCsTmKbkA",
      authDomain: "emmaapp-cd6e8.firebaseapp.com",
      databaseURL: "https://emmaapp-cd6e8.firebaseio.com",
      projectId: "emmaapp-cd6e8",
      storageBucket: "",
      messagingSenderId: "739124619175"
    };
firebase.initializeApp(config);

@NgModule({
  declarations: [
    MyApp,
    FeedingPage,
    DiapersPage,
    HomePage,
    TabsPage,
    LoginPage,
    SignupPage,
    FeedingModalComponent,
    DiaperModalComponent,
    TypesModalComponent,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot(),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    FeedingPage,
    DiapersPage,
    HomePage,
    TabsPage,
    LoginPage,
    SignupPage,
    FeedingModalComponent,
    DiaperModalComponent,
    TypesModalComponent,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    DataServiceProvider,
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts